export function safeGetUri(uri: string, defaultUri = '/'): string {
  try {
    const newUrl = new URL(uri, 'https://cloud.digitalocean.com');
    return newUrl.pathname + newUrl.search ?? defaultUri;
  } catch (e) {
    console.error('Unable to parse', uri, 'returning default');
    return defaultUri;
  }
}
